import { render, staticRenderFns } from "./PropertyPool.vue?vue&type=template&id=818505d2"
import script from "./PropertyPool.vue?vue&type=script&lang=js"
export * from "./PropertyPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports